/**
 * Form adapter component
 *
 * @overview uses Formik
 */
import { Formik } from 'formik';

import { FormError, Place } from './form.styled';

/**
 * errors component
 * @param formik
 * @param absoluteErrors
 * @returns
 */
export const getErrors = (formik, absoluteErrors = false) => {
  if (!formik.errors.api) {
    return null;
  }

  return (
    <FormError absoluteErrors={absoluteErrors}>
      <p>{formik.errors.api}</p>
    </FormError>
  );
};

/**
 * form component
 * @param props
 * @returns
 */
export const Form = (props) => {
  const { children, onSubmit, debug, absoluteErrors, hideLoading, ...rest } = props;

  const customOnSubmit = (values, helpers) => {
    return onSubmit(values, helpers);
  };

  return (
    <Formik {...rest} onSubmit={customOnSubmit}>
      {(formik) => {
        // console.log('🚀 ~ Form ~ formik:', formik);
        const isFunc = typeof children === 'function';
        const errors = getErrors(formik, absoluteErrors);
        const data = isFunc ? children(formik) : children;
        const cl = !hideLoading && formik.isSubmitting ? 'loading' : '';
        //console.log('🚀 ~ Form ~ formik.isSubmitting:', formik.isSubmitting);
        return (
          <Place className={cl}>
            <form onSubmit={formik.handleSubmit}>{data}</form>
            {!isFunc && errors}
            {debug && <pre>{JSON.stringify(formik, null, 2)}</pre>}
          </Place>
        );
      }}
    </Formik>
  );
}

export default Form;
